import React from "react";
import NavBar from "components/NavBar";
import BreadCrumb from '../components/Breadcumb';


interface Props {
  children?: React.ReactNode;
}

const StandardLayout = (props: Props) => {
  return (
    <div>
      <NavBar />

      {/* <BreadCrumb/> */}
      <div>{props.children}</div>
    </div>
  );
};

export default StandardLayout;
